import React from 'react';
import { format } from 'date-fns';
import { Dialog, Text } from 'evergreen-ui';
import { useSelector } from 'react-redux';
import { timeZoneSelector } from 'Features/App/appSlice';
import { UTCtoTimeZone } from 'Utils/UTCConverter';

export function NotifyDialog({
  data = {},
  closeDialog = () => {},
  onConfirm = () => {},
  multiple,
  isConfirmDisabled,
}) {
  const { notificationType = {}, creationDateTimeUTC, text, events } = data;
  const selectedZone = useSelector(timeZoneSelector);

  const title = React.useMemo(() => {
    const cDate = creationDateTimeUTC
      ? UTCtoTimeZone(creationDateTimeUTC, selectedZone.selectedUserTimeZone)
      : '';
    return multiple ? 'Прочитать выбранные' : `${cDate} UTC${selectedZone.selectedUserTimeZone} | ${notificationType.name}`;
  }, [creationDateTimeUTC, multiple, notificationType.name, selectedZone.selectedUserTimeZone]);

  const createMarkup = React.useCallback(() => {
    let eventStr = '';
    if (events?.length) {
      events.forEach((event) => {
        eventStr += `${event.creationDateTimeUTC
          ? `<b>Дата создания: ${format(new Date(event.creationDateTimeUTC), 'dd.MM.yyyy HH:mm')}</b> <br />`
          : ''}
          ${event.datasource ? `Источник данных: ${event.datasource.id} <br /> ` : ''}  <br />
          ${event.station ? `Станция: ${event.station.name}  <br />` : ''} <br />
          ${event.userName ? `Пользователь: ${event.userName} <br />` : ''}
          <br />
           `;
      });
    }
    const newstr = text?.replace(/\n/g, '<br />');
    return {
      __html: eventStr + newstr ?? '',
    };
  }, [events, text]);

  return (
    <Dialog
      isShown
      onCloseComplete={closeDialog}
      confirmLabel={multiple ? 'Прочитать выбранные' : 'Отметить прочитанным'}
      cancelLabel="Закрыть"
      title={title}
      onConfirm={onConfirm}
      isConfirmDisabled={isConfirmDisabled}
      shouldCloseOnOverlayClick={false}
    >
      {
        multiple
          ? 'Отметить прочитанными выбранные уведомления ?'
          : <Text dangerouslySetInnerHTML={createMarkup()} />
      }

    </Dialog>
  );
}
